import React from 'react';
export function CrossCircleFillIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11zm3.793-5.793L12 13.414l-3.793 3.793-1.414-1.414L10.586 12 6.793 8.207l1.414-1.414L12 10.586l3.793-3.793 1.414 1.414L13.414 12l3.793 3.793-1.414 1.414z"
  }));
}